<template>
    <div class="recipes-graph">
        <cytoscape
            ref="cy"
            :config="config"
            :afterCreated="afterCreated"
            :preConfig="preConfig"
        >
        </cytoscape>
    </div>
</template>

<script>
import dagre from "cytoscape-dagre"

export default {
    props: {
        items: {
            type: Object,
            required: true,
        },
        recipes: {
            type: Object,
            required: true,
        }
    },

    data() {
        let elements = [];
        let existing = [];
        for (const sku in this.recipes) {
            if (existing.indexOf(sku) < 0) {
                elements.push({
                    data: {
                        id: sku,
                    },
                    style: {
                        "text-wrap": "wrap",
                        "label": this.getNodeLabel(sku),
                        //"border-style": !!this.items[sku] ? 'solid' : 'dashed',
                        "border-style": this.recipes[sku].type === 'product' ? 'solid' : (!!this.items[sku] ? 'solid' : 'dashed'),
                        //"border-color": !!this.items[sku] ? '#000' : 'red',
                        "border-color": this.recipes[sku].type === 'product' ? '#2b78e4' : (!!this.items[sku] ? '#000' : 'red'),
                        "background-color": this.recipes[sku].type === 'product' ? '#89a9d5' : '',
                        "shape": this.recipes[sku].type === 'product' ? 'rectangle' : 'round-rectangle',
                    },
                    group: "nodes",
                });

                // Create item root node and edge
                if (this.recipes[sku].root) {
                    // Create item root node
                    elements.push({
                        data: {
                            id: 'LEAF-' + sku,
                            root: true,
                        },
                        style: {
                            "shape": 'ellipse',
                            "width": 10,
                            "height": 10,
                            "background-opacity": 1,
                            "background-color": '#aaaaaa',
                            "border-color": '#aaaaaa',
                        },
                        group: "nodes",
                    });

                    // Create item root edge
                    elements.push({
                        data: {
                            id: 'LEAF-' + sku + '-' + sku,
                            source: 'LEAF-' + sku,
                            target: sku,
                        },
                        style: {
                            "targetLabel": this.recipes[sku].quantity + ' ' + this.recipes[sku].unit,
                        },
                        group: "edges",
                    });
                }
                existing.push(sku);
            }
            for (const ingredientSku in this.recipes[sku].ingredients) {
                if (existing.indexOf(ingredientSku) < 0) {
                    // Create ingredient node
                    elements.push({
                        data: {
                            id: ingredientSku,
                        },
                        style: {
                            "shape": this.recipes[sku].ingredients[ingredientSku].type === 'product' ? 'rectangle' : 'round-rectangle',
                            "text-wrap": "wrap",
                            "label": this.getNodeLabel(ingredientSku),
                            "border-style": !!this.items[ingredientSku] ? 'solid' : 'dashed',
                            "border-color": !!this.items[ingredientSku] ? '#000' : 'red',
                        },
                        group: "nodes",
                    });
                    existing.push(ingredientSku);

                    // Create ingredient root ellipse and edge
                    if (!this.recipes[ingredientSku] || this.recipes[ingredientSku].root) {
                        // Create item root ellipse
                        elements.push({
                            data: {
                                id: 'LEAF-' + ingredientSku,
                                root: true,
                            },
                            style: {
                                "shape": 'ellipse',
                                "width": 10,
                                "height": 10,
                                "background-color": !!this.recipes[ingredientSku] ? '#aaaaaa' : 'red',
                                "background-opacity": 1,
                                "border-color": !!this.recipes[ingredientSku] ? '#aaaaaa' : 'red',
                                "label": !!this.recipes[ingredientSku] ? '' : 'Pas de recette !',
                            },
                            group: "nodes",
                        });

                        // Create item root edge
                        elements.push({
                            data: {
                                id: 'EDGE-LEAF-' + ingredientSku,
                                source: 'LEAF-' + ingredientSku,
                                target: ingredientSku,
                            },
                            style: {
                                "line-color": !!this.recipes[ingredientSku] ? '#cccccc' : 'red',
                                "target-arrow-color": !!this.recipes[ingredientSku] ? '#cccccc' : 'red',
                                "targetLabel": (this.recipes[ingredientSku] && this.recipes[ingredientSku].root) ? this.recipes[ingredientSku].quantity + ' ' + this.recipes[ingredientSku].unit : '',
                            },
                            group: "edges",
                        });
                    }
                }

                // Create ingredient edge
                elements.push({
                    data: {
                        id: ingredientSku + '-' + sku,
                        source: ingredientSku,
                        target: sku,
                    },
                    style: {
                        "sourceLabel": this.recipes[sku].ingredients[ingredientSku].quantity + ' ' + this.recipes[sku].ingredients[ingredientSku].unit,
                        "targetLabel": this.recipes[sku].quantity + ' ' + this.recipes[sku].unit,
                    },
                    group: "edges",
                });
            }
        }

        return {
            config: {
                style: [
                    {
                        selector: "node",
                        style: {
                            "background-opacity": "1",
                            "background-color": "#eeeeee",
                            "border-color": "#000",
                            "border-width": "1px",
                            "width": "50px",
                            "shape": 'rectangle',
                            "text-halign": "center",
                            "text-valign": "center",
                            "font-size": "5px",
                        }
                    },
                    {
                        selector: "edge",
                        style: {
                            "width": 3,
                            "line-color": "#cccccc",
                            "target-arrow-color": "#cccccc",
                            "target-arrow-shape": "triangle",
                            "source-endpoint": "outside-to-node-or-label",
                            "target-endpoint": "outside-to-node-or-label",
                            "curve-style": "bezier",
                            "font-size": "7px",
                            "source-text-offset": "10px",
                            "target-text-offset": "10px",
                        }
                    }
                ],
                layout: {
                    name: 'dagre',
                    rankDir: 'LR',
                },
                elements:  elements,
            }
        };
    },

    methods: {
        getNodeLabel(sku) {
            return !!this.items[sku]
                ? this.items[sku].name + '\n' + sku
                : sku
        },

        onClickNode(event) {
            console.log('node clicked', event.target.data());
            const sku = event.target.data('id');
            const componentExists = !!this.items[sku] && this.items[sku].type === 'component';
            if (componentExists) {
                if (confirm('Voulez-vous modifier le composant "' + sku + "' ?")) {
                    location = '/espace-employes/production/composants/' + sku + '/modifier';
                }
            }
        },

        onClickEdge(event) {
            console.log('edge clicked', event.target.data());
            const sku = event.target.data('target');
            const recipeExists = !!this.recipes[sku];
            if (recipeExists) {
                if (confirm('Voulez-vous modifier la recette de "' + sku + "' ?")) {
                    location = '/espace-employes/production/recettes/par-sku/' + sku + '/modifier';
                }
            } else {
                if (confirm('Voulez-vous créer la recette de "' + sku + "' ?")) {
                    location = '/espace-employes/production/recettes/par-sku/' + sku + '/creer';
                }
            }
        },

        preConfig(cy) {
            console.log("calling pre-config", cy);
            cy.use(dagre);
        },

        afterCreated(cy) {
            console.log("after created", cy);

            cy.on('click', 'node', this.onClickNode);
            cy.on('click', 'edge', this.onClickEdge);
        },
    }
};
</script>

<style lang="scss">
.recipes-graph {
    border: 1px solid #000000;
}
</style>
